export default __webpack_public_path__ + "static/media/Mark-3-HUD-Pop-Up (3 Layers).d4328d37.jpg";